exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3zB2Rl39Vu-9wkfrQEjhFN,.bbn0bZh6nviYfJHX7-H1b{display:-webkit-box;display:-ms-flexbox;display:flex}.KYXCsfKtJQLNrWOeOeti5{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] .KYXCsfKtJQLNrWOeOeti5{margin-top:2px}html[dir=ltr] .KYXCsfKtJQLNrWOeOeti5{padding-left:0}html[dir=rtl] .KYXCsfKtJQLNrWOeOeti5{padding-right:0}html[dir] ._2RIuOOSOedtGLkn7PHouBw{margin-top:8px}", ""]);

// exports
exports.locals = {
	"ignoreSubsequentRulesCheckbox": "_3zB2Rl39Vu-9wkfrQEjhFN",
	"runRuleNowCheckbox": "bbn0bZh6nviYfJHX7-H1b",
	"ignoreSubsequentRulesLearnMore": "KYXCsfKtJQLNrWOeOeti5",
	"infoIcon": "_2RIuOOSOedtGLkn7PHouBw"
};